import { useEffect, useState } from 'react'

import Input from '@/components/form/Input'
import { Translation } from '@/components/i18n/Translation'

import './new-customer-address.scss'

const NewCustomerAddress = ({ header, dispatchAddress, disabled = false }: any) => {
  const [line1, setLine1] = useState('')
  const [line2, setLine2] = useState('')
  const [zip, setZip] = useState('')
  const [city, setCity] = useState('')

  useEffect(() => {
    dispatchAddress({
      line1,
      line2,
      zip,
      city,
    })
  }, [line1, line2, zip, city, dispatchAddress])

  return (
    <div className="card new-customer-address">
      {header && <h2>{header}</h2>}

      <Input
        label={<Translation id="Address line 1" />}
        className="address-line-1"
        value={line1}
        onChange={e => setLine1(e.target.value)}
        disabled={disabled}
      />

      <Input
        label={<Translation id="Address line 2" />}
        className="address-line-2"
        value={line2}
        onChange={e => setLine2(e.target.value)}
        disabled={disabled}
      />

      <div className="zip-city">
        <div className="zip">
          <Input
            // todo: Add validation when refactoring to avoid bugs of missing leading 0s
            label={<Translation id="Zip" />}
            value={zip}
            maxLength={10}
            onChange={e => setZip(e.target.value)}
            disabled={disabled}
          />
        </div>

        <div className="city">
          <Input
            label={<Translation id="City" />}
            value={city}
            onChange={e => setCity(e.target.value)}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  )
}

export default NewCustomerAddress
